var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82098 1.50142C-2.76605 5.97468 2.38887 10.8835 8.58142 17.1034C9.38061 17.7552 10.7713 18.7954 9.94045 17.7414C8.90191 16.4239 10.4926 13.0326 11.7272 8.64103C12.9619 4.24945 6.40802 -2.97184 1.82098 1.50142Z",
    fill: "#834D8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot1);
export default __webpack_public_path__ + "static/media/dot1.62287f8469d5e21f403d866ae64bcb33.svg";
export { ForwardRef as ReactComponent };